// eslint-disable-next-line import/prefer-default-export
export const adgAdDefaultConfig = {
    id: '',
    targetID: '',
    displayid: '',
    adType: '',
    async: 'true',
    tagver: '',
    preFixId: 'div-gpt-ad-',
    defineSlot: {
        link: '/49720294/auportal_sp_easygame_diceconnecting_320x100', //string define
        size: [320, 100] //array or multiple [320, 100] or [[300, 250], [336, 280]]
    }
};
